import React from 'react'
import './userBasicProfileV3.css';
import UserAvatar from 'components/userAvatar';
import { Button } from 'components/Button';
import { Api } from 'services'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setUserProfileDetailsV3 } from 'actions/userManagementV2';
import { connect } from 'react-redux';
import { RightOutlined } from '@ant-design/icons';
import moment from 'moment';

// No photo (null/undefined/"default.png") -> empty string, so UserAvatar
// falls back to the name's initials instead of trying to load a broken
// ".../undefined" or ".../default.png" URL.
const resolveStaffImageUrl = (image) => {
    if (!image || image === "default.png") return "";
    return image.startsWith("http") ? image : `${Api._s3_url}${image}`;
};

const getStatusDotColor = (status) => (
    status === "Suspended" ? "#FF414D" : "#00A566"
);

const UserProfileV3 = ({ specificUserProfile, setUserProfileDetailsV3, isScrolled }) => {

    const history = useHistory();
    const location = useLocation();
    const basePath = location.pathname.startsWith('/user-management-v2') ? '/user-management-v2' : '/user-management';
    // getStaffProfile (/userv2/staff/:id) returns these flat on the record
    // now (currentHouseNo/currentDistrict/... etc.) — there's no more
    // nested `basicprofile` object with JSON-stringified addresses.
    const permanentAddress = {
        h_no: specificUserProfile?.permanentHouseNo,
        city: specificUserProfile?.permanentDistrict,
        state: specificUserProfile?.permanentState,
        country: specificUserProfile?.permanentCountry,
        pincode: specificUserProfile?.permanentPincode,
    };
    const currentAddress = {
        h_no: specificUserProfile?.currentHouseNo,
        city: specificUserProfile?.currentDistrict,
        state: specificUserProfile?.currentState,
        country: specificUserProfile?.currentCountry,
        pincode: specificUserProfile?.currentPincode,
    };


    const assignUserDetails = () => {
        // userEditProfileV3 still reads userProfileDetailsV3 in the older
        // shape (currentAddress/permanentAddress as JSON strings,
        // attendanceEmpCode, emergencyPhone, relationship) — re-stringified
        // here so that page doesn't also need to change.
        setUserProfileDetailsV3("name", specificUserProfile?.name)
        setUserProfileDetailsV3("phone", specificUserProfile?.phone)
        setUserProfileDetailsV3("image", specificUserProfile?.image)
        setUserProfileDetailsV3("role", specificUserProfile?.role)
        setUserProfileDetailsV3("email", specificUserProfile?.email)
        setUserProfileDetailsV3("privilage", specificUserProfile?.privilages)
        setUserProfileDetailsV3("designation", specificUserProfile?.designation)
        setUserProfileDetailsV3("bloodGroup", specificUserProfile?.bloodGroup)
        setUserProfileDetailsV3("dob", specificUserProfile?.dob)
        setUserProfileDetailsV3("gender", specificUserProfile?.gender)
        setUserProfileDetailsV3("emergencyContactName", specificUserProfile?.emergencyContactName)
        setUserProfileDetailsV3("emergencyPhone", specificUserProfile?.emergencyContactPhone)
        setUserProfileDetailsV3("relationship", specificUserProfile?.emergencyContactRelationship)
        setUserProfileDetailsV3("attendanceEmpCode", specificUserProfile?.employeeId)
        setUserProfileDetailsV3("currentAddress", JSON.stringify(currentAddress))
        setUserProfileDetailsV3("permanentAddress", JSON.stringify(permanentAddress))
    }

    return (
        <div className='compact-profile-card' style={{ height: isScrolled ? '7%' : '55%', transition: 'height 1s ease' }}>
            {isScrolled ? (
                <div className='user-profile-row'>
                    <div className="user-profile-v3">
                        <UserAvatar
                            name={specificUserProfile?.name}
                            img={resolveStaffImageUrl(specificUserProfile?.image)}
                            size={35}
                            style={{ marginRight: 16 }}
                        />

                        <div className="user-name">{specificUserProfile?.name} </div>
                        <div style={{ color: getStatusDotColor(specificUserProfile?.status), fontSize: 20, marginLeft: 10 }}>•</div>
                        <div className="user-contact">{specificUserProfile?.phone}</div>
                        <div className="user-role">{specificUserProfile?.role}</div>
                        <RightOutlined className="arrow-icon" />
                    </div>
                </div>
            ) : (
                <div className='full-height-flex'>
                    <div className='profile-left-part'>
                        <div className='flex-column-bordered'>
                            <div>
                                <div className='avatar-centered-flex'>
                                    <UserAvatar size={130} shape="circle" name={specificUserProfile?.name}
                                        img={resolveStaffImageUrl(specificUserProfile?.image)}
                                        fontWeight={true} />
                                </div>
                                <div className='avatar-name-style'>
                                    <div className='name-style-v3'>{specificUserProfile?.name}</div>
                                    <div className='green-text-large' style={{ color: getStatusDotColor(specificUserProfile?.status) }}>•</div>
                                </div>
                                <div className='email-role-container'>{specificUserProfile?.phone}</div>
                                <div className='email-role-container'>{specificUserProfile?.role}</div>
                            </div>

                            <div className='centered-flex-profile'>
                                <Button className='edit-profile-button' type="link"
                                    onClick={(e) => {
                                        // clearValues();
                                        e.stopPropagation();
                                        assignUserDetails();
                                        history.push({
                                            pathname: `${basePath}/edit-profile`,
                                            state: {
                                                key: {
                                                    isEdit: "isFromEdit",
                                                    fromUserProfileV3: true,
                                                }
                                            }
                                        });
                                    }}
                                >EDIT PROFILE</Button>
                            </div>
                        </div>
                    </div>

                    <div className='profile-right-side-full-width-height'>
                        <div className='profile-right-container-full-width-padding'>
                            <div className='full-size'>
                                <div className='basic-info-style'>
                                    <div className='basic-first-info'>Basic information</div>
                                    <div className="flex-container">
                                        <div className="basicprofile-section" style={{ width: '40%' }}>
                                            <div className="profile-title">
                                                <div className="profile-label">Email ID</div>
                                                <div>{specificUserProfile?.email}</div>
                                            </div>
                                        </div>
                                        <div className="basicprofile-section" style={{ width: '15%' }}>
                                            <div className="profile-title">
                                                <div className="profile-label">Designation</div>
                                                <div>{specificUserProfile?.designation}</div>
                                            </div>
                                        </div>
                                        <div className="basicprofile-section" style={{ width: '15%' }}>
                                            <div className="profile-title">
                                                <div className="profile-label">DOB</div>
                                                <div>{specificUserProfile?.dob ? moment(specificUserProfile.dob).format('DD/MM/YYYY') : '-'}</div>
                                            </div>
                                        </div>
                                        <div className="basicprofile-section" style={{ width: '15%' }}>
                                            <div className="profile-title">
                                                <div className="profile-label">Gender</div>
                                                <div>{specificUserProfile?.gender}</div>
                                            </div>
                                        </div>
                                        <div className="basicprofile-section" style={{ width: '15%' }}>
                                            <div className="profile-title">
                                                <div className="profile-label">Blood group</div>
                                                <div>{specificUserProfile?.bloodGroup}</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="address-container">
                                    <div className="address-title">Current address</div>
                                    <div className="address-flex">
                                        <div className="address-section" style={{ width: '40%' }}>
                                            <div>
                                                <div className="address-label">House No./Locality/Area</div>
                                                <div>{currentAddress?.h_no}</div>
                                            </div>
                                        </div>
                                        <div className="address-section" style={{ width: '15%' }}>
                                            <div>
                                                <div className="address-label">District</div>
                                                <div>{currentAddress?.city}</div>
                                            </div>
                                        </div>
                                        <div className="address-section" style={{ width: '15%' }}>
                                            <div>
                                                <div className="address-label">State</div>
                                                <div>{currentAddress?.state}</div>
                                            </div>
                                        </div>
                                        <div className="address-section" style={{ width: '15%' }}>
                                            <div>
                                                <div className="address-label">Country</div>
                                                <div>{currentAddress?.country}</div>
                                            </div>
                                        </div>
                                        <div className="address-section" style={{ width: '15%' }}>
                                            <div>
                                                <div className="address-label">Pincode</div>
                                                <div>{currentAddress?.pincode}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="permanent-address-container">
                                    <div className="permanent-address-title">Permanent address</div>
                                    <div className="permanent-address-flex">
                                        <div className="permanent-address-section" style={{ width: '40%' }}>
                                            <div>
                                                <div className="permanent-address-label">House No./Locality/Area</div>
                                                <div>{permanentAddress?.h_no}</div>
                                            </div>
                                        </div>
                                        <div className="permanent-address-section" style={{ width: '15%' }}>
                                            <div>
                                                <div className="permanent-address-label">District</div>
                                                <div>{permanentAddress?.city}</div>
                                            </div>
                                        </div>
                                        <div className="permanent-address-section" style={{ width: '15%' }}>
                                            <div>
                                                <div className="permanent-address-label">State</div>
                                                <div>{permanentAddress?.state}</div>
                                            </div>
                                        </div>
                                        <div className="permanent-address-section" style={{ width: '15%' }}>
                                            <div>
                                                <div className="permanent-address-label">Country</div>
                                                <div>{permanentAddress?.country}</div>
                                            </div>
                                        </div>
                                        <div className="permanent-address-section" style={{ width: '15%' }}>
                                            <div>
                                                <div className="permanent-address-label">Pincode</div>
                                                <div>{permanentAddress?.pincode}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="emergency-contact-container">
                                    <div className="emergency-contact-title">Emergency contact</div>
                                    <div className="emergency-contact-flex">
                                        <div className="emergency-contact-section" style={{ width: '40%' }}>
                                            <div>
                                                <div className="emergency-contact-label">Name</div>
                                                <div>{specificUserProfile?.emergencyContactName}</div>
                                            </div>
                                        </div>
                                        <div className="emergency-contact-section" style={{ width: '15%' }}>
                                            <div>
                                                <div className="emergency-contact-label">Mobile No.</div>
                                                <div>{specificUserProfile?.emergencyContactPhone}</div>
                                            </div>
                                        </div>
                                        <div className="emergency-contact-section" style={{ width: '15%' }}>
                                            <div>
                                                <div className="emergency-contact-label">Relationship</div>
                                                <div>{specificUserProfile?.emergencyContactRelationship}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

const mapStateToProps = (state) => {
    const { userProfileDetailsV3 } = state.userManagementV2
    return {
        userProfileDetailsV3
    };
};

const mapDispatchToProps = (dispatch) => ({
    setUserProfileDetailsV3: (key, val) => dispatch(setUserProfileDetailsV3(key, val)),
});


export default connect(mapStateToProps, mapDispatchToProps)(UserProfileV3);
